import { render } from "./IzinKaryawan.vue?vue&type=template&id=5c4cdc28"
import script from "./IzinKaryawan.vue?vue&type=script&lang=js"
export * from "./IzinKaryawan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__